import React from 'react';
import { Box, Typography } from '@mui/material';
import { styled } from '@mui/system';
import { useSectionData } from '../hooks/useFirebaseData';
import DescriptionSkeleton from "./ui/DescriptionSkeleton";

const RoundedImage = styled('img')({
    width: '205px',
    height: '250px',
    borderRadius: '5%',
    objectFit: 'cover',
});

const Trainer = () => {
    const {
        data: trainerData,
        loading,
        error,
    } = useSectionData("trainer", "trainer");
    
    console.log("trainer", trainerData || undefined);
    
    // Show loading state
    if (loading) {
        return (
           <DescriptionSkeleton/>
        );
    }
    
    // Show error state
    if (error) {
        return (
            <Box sx={{ padding: 8, textAlign: 'center' }}>
                <Typography 
                    variant="h5" 
                    sx={{ 
                        color: 'error.main', 
                        fontWeight: 'bold', 
                        marginBottom: 1, 
                        fontSize: { xs: '1.75rem', md: '2rem' },
                    }}
                >
                    データの読み込み中にエラーが発生しました
                </Typography>
            </Box>
        );
    }
    
    // If no data, show nothing or a simple message
    if (!trainerData) {
        return (
            <Box sx={{ padding: 8, textAlign: 'center' }}>
                <Typography 
                    variant="h5" 
                    sx={{ 
                        color: '#E87F11', 
                        fontWeight: 'bold', 
                        marginBottom: 1, 
                        fontSize: { xs: '1.75rem', md: '2rem' },
                    }}
                >
                    データがありません
                </Typography>
            </Box>
        );
    }
    
    // Use Firebase data
    return (
        <Box sx={{ padding: 8 }}>
            <Typography 
                variant="h5" 
                sx={{ 
                    color: '#E87F11', 
                    fontWeight: 'bold', 
                    marginBottom: 1, 
                    fontSize: { xs: '1.75rem', md: '2rem' },
                    textAlign: { xs: 'center', md: 'left' } 
                }}
            >
                {trainerData.Trainer_title}
            </Typography>
            <Box sx={{ display: 'flex', flexDirection: { xs: 'column', md: 'row' }, gap: 4, justifyContent: 'center', alignItems: 'center' }}>
                <Box>
                    <RoundedImage 
                        src={trainerData.image} 
                        alt="トレーナー" 
                        onError={(e) => {
                            e.target.style.display = 'none';
                        }}
                    />
                </Box>
                <Box flex={1} display="flex" flexDirection="column" justifyContent="center" alignItems="flex-start" padding={2}>
                    <Typography 
                        variant="h5" 
                        sx={{ 
                            color: '#E87F11', 
                            fontWeight: 'bold', 
                            marginBottom: 1, 
                            fontSize: { xs: '1.75rem', md: '2rem' },
                            textAlign: { xs: 'center', md: 'left' } 
                        }}
                    >
                        {trainerData.Trainer_name}
                    </Typography>
                    <Typography 
                        variant="body1" 
                        sx={{ 
                            color: '#E87F11', 
                            fontSize: { xs: '1.25rem', md: '1.50rem' },
                            whiteSpace: 'pre-line'
                        }}
                    >
                        {trainerData.Trainer_description}
                    </Typography>
                </Box>
            </Box>
        </Box>
    );
};

export default Trainer;